import Details from './Details';
export type { DetailsProps } from './Details.types';

export default Details;
